<template>
  <section class="hero is-fullheight fondo">
    <div class="hero-body">
      <div class="container">
        <div class="box login-box">
          <div class="login-header">
            <div class="login-logo">
              <b-icon icon="storefront" size="is-small" />
            </div>
            <h1 class="login-title">Sistema de Ventas</h1>
            <p class="login-subtitle">Accede con tus credenciales</p>
          </div>

          <form @submit.prevent="iniciarSesion">
            <b-field label="Usuario">
              <b-input
                icon="account"
                type="text"
                placeholder="Nombre de usuario"
                v-model="usuario.usuario"
                size="is-small"
              />
            </b-field>

            <b-field label="Contraseña">
              <b-input
                icon="lock"
                type="password"
                placeholder="••••••••"
                v-model="usuario.password"
                password-reveal
                size="is-small"
              />
            </b-field>

            <b-button
              type="is-primary"
              size="is-medium"
              icon-left="login"
              native-type="submit"
              :loading="cargando"
              expanded
              class="mt-4 login-btn"
            >
              Ingresar
            </b-button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import AyudanteSesion from "../../Servicios/AyudanteSesion";

export default {
  name: "InicioSesionComponent",

  data: () => ({
    cargando: false,
    usuario: {
      usuario: "",
      password: "",
    },
  }),

  methods: {
    iniciarSesion() {
      if (this.cargando) return;
      if (!this.usuario.usuario || !this.usuario.password) {
        this.$buefy.toast.open({
          type: "is-warning",
          message: "Completa todos los campos.",
        });
        return;
      }

      this.cargando = true;
      let payload = { accion: "iniciar_sesion", usuario: this.usuario };

      HttpService.obtenerConConsultas("usuarios.php", payload)
        .then((resultado) => {
          if (!resultado) {
            this.$buefy.toast.open({
              type: "is-danger",
              message: "Credenciales incorrectas. Verifica.",
            });
            return;
          }
          if (resultado.estado) {
            this.$buefy.toast.open({
              type: "is-success",
              message: "¡Bienvenido!",
            });
            // Setear sesión ANTES de navegar para que beforeEach ya tenga el usuario.
            // Los permisos completos los cargará App.vue vía $emit("sesion").
            AyudanteSesion.setSesion(resultado.usuario, {});
            this.$emit("sesion");
            this.$router.push({ name: "InicioComponent" });
          }
        })
        .finally(() => {
          this.cargando = false;
        });
    },
  },
};
</script>

<style scoped>
.login-box {
  animation: fadeUp 0.4s ease both;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-logo {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 60px;
   height: 60px;
   background: var(--color-primary-transparent-12);
   border: 1px solid var(--color-primary-transparent-25);
   border-radius: 16px;
   margin-bottom: 1rem;
   color: var(--color-primary);
 }

.login-title {
   font-size: 1.5rem;
   font-weight: 700;
   color: var(--color-text);
   margin-bottom: 0.25rem;
 }

.login-subtitle {
   font-size: 0.875rem;
   color: var(--color-text-muted);
 }

.login-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em !important;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
